<template>
  <div class="service">
    <div class="service-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        服务
      </div>
      <div class="service-content service-fill">
        <div class="service-content-title">线下服务</div>
        <div class="service-content-catery">
          <router-link :to="{path: 'address'}">
            <div class="service-content-catery-reag">
              <img src="../../public/obraoag/serviceReag.png" alt="">
              <p>购卡充值网点</p>
            </div>
          </router-link>
          <div class="service-content-catery-reag" @click="servcent()">
            <img src="../../public/obraoag/serviceCuer.png" alt="">
            <p>客服</p>
          </div>
        </div>
      </div>
      <div class="service-content">
        <div class="service-content-title">线上服务</div>
        <router-link :to="{path: 'register',query: {siyzstate: '14',servmope: '2'}}">
          <div class="service-content-catery">
            <div class="service-content-catery-reag">
              <img src="../../public/obraoag/servicePant.png" alt="">
              <p>支付密码管理</p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="service-content">
        <div class="service-content-title">帮助中心</div>
        <router-link :to="{path: 'MessCent', query: {servhelp: '0'}}">
          <div class="service-content-catery">
            <div class="service-content-catery-reag">
              <img src="../../public/obraoag/serviceHelp.png" alt="">
              <p>帮助</p>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 提示语 -->
    <div class="js_dialog" id="iosDialog2" :style="'display:' + servhint">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">客服电话: 4009284868<br>周一至周六 9:00 - 11:30 14:00 - 17:30</div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="servclpt()" style="color: #f10100">知道了</a>
        </div>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      servhint: 'none'
    }
  },
  created () {
    
  },
  mounted () {

  },
  methods: {
    // 点击客服出现提示框
    servcent(){
      this.servhint = 'block';
    },
    // 点击知道了隐藏提示框
    servclpt(){
      this.servhint = 'none';
    },
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'HomePage'});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/service.css";
</style>